import axios from 'axios'
import base from '@/api/base.api';

const namespace = 'transaction-history';

export default {
    getInfoTransaction: (orderId, organizationId) => {
        return axios.get(`${base.baseUrl}/${namespace}/list/get-transaction-info-for-receipt/${orderId}/${organizationId}`);
    },
    getReceiptPDF: (orderId, organizationId) => {
        // I02112026: get-recipt-external ahora devuelve el PDF binario (ya no la URL interna de Carbone).
        return axios.get(`${base.baseUrl}/${namespace}/get-recipt-external/${orderId}/${organizationId}`, { responseType: 'blob' });
    },
}
